import { Link, useLocation } from 'react-router-dom'
import { NAVIGATION_GROUPS } from '../../navigation'
import { buildBreadcrumbTrail } from './helpers/buildBreadcrumbTrail'
import './Breadcrumbs.css'

export function Breadcrumbs() {
  const { pathname } = useLocation()
  const trail = buildBreadcrumbTrail(NAVIGATION_GROUPS, pathname)

  if (trail.length === 0) {
    return null
  }

  return (
    <nav aria-label="Breadcrumb" className="breadcrumbs">
      <ol className="breadcrumbs__list">
        {trail.map((crumb, index) => {
          const isCurrent = index === trail.length - 1
          return (
            <li key={`${crumb.label}-${index}`} className="breadcrumbs__item">
              {crumb.to ? (
                <Link to={crumb.to} className="breadcrumbs__link">
                  {crumb.label}
                </Link>
              ) : (
                <span
                  className={
                    isCurrent ? 'breadcrumbs__current' : 'breadcrumbs__group'
                  }
                  aria-current={isCurrent ? 'page' : undefined}
                >
                  {crumb.label}
                </span>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
